import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import {actions} from '../constants/address/billing_address_actions';
import BillingAddress from './models/billing_address';

class BillingAddressStoreClass extends ReduceStore {
    getInitialState() {
        return {
            address: new BillingAddress,
            invalid: [],
        };
    }

    reduce( state, { source, action } ) {
        if ( source === ACTION_TYPES.BILLING_ADDRESS_ACTION ) {
            switch (action.type) {
                case actions.SET_FIRST_NAME:
                    if (action.payload !== state.address.firstName) {
                        state.address.firstName = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.SET_MARKETING_CONSENT:
                    if (action.payload !== state.address.marketingConsent) {
                        state.address.marketingConsent = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.SET_LAST_NAME:
                    if (action.payload !== state.address.lastName) {
                        state.address.lastName = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.SET_EMAIL:
                    if (action.payload !== state.address.email) {
                        state.address.email = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.SET_TELEPHONE:
                    if (action.payload !== state.address.telephone) {
                        state.address.telephone = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.SET_INVALID:
                    if (state.invalid.indexOf(action.payload) < 0) {
                        state.invalid.push(action.payload);
                        this.__emitChange();
                    }
                    break;
                case actions.UNSET_INVALID:
                    if (state.invalid.indexOf(action.payload) > -1) {
                        state.invalid.splice(state.invalid.indexOf(action.payload), 1);
                        this.__emitChange();
                    }
                    break;
                case actions.RESET_INVALID:
                    state.invalid = [];
                    this.__emitChange();
                    break;
            }
        }

        return state;
    }
}

const BillingAddressStore = new BillingAddressStoreClass( Dispatcher );
export default BillingAddressStore;
